const Index = () => import('@/views/material/Index')
export default [{
  path: '/material',
  meta: {
    title: '物料管理',
    activeMenu: '/home/board'
  },
  components: {
    right: Index
  }
}]
